import { useState, useContext, useEffect, useRef } from 'react';
import { UserContext } from '../../global/globalContext/context';
import { Button, Col, Row, Spinner } from 'reactstrap'
import Layout from '../../layout/index';
import styles from './HomePage.module.scss';
import { showMsg } from '../../global/langs/langs';
import AdsSections from './Sections/AdsSections';
import TabSections from './Sections/TabSections';
import { getRequest } from '../../global/utils/apiCall';
import Product from '../../global/Components/Items/Product/Product';
import { useNavigate } from 'react-router-dom';
import Category from '../../global/Components/Items/Category/Category';
import CategoriesIconSection from './Sections/CategoriesIconSection';
import Search from '../../global/Components/Search/Search';
import VendorCard from '../../global/Components/Items/Vendor/VendorCard';
import Carousel from '../../global/Components/Items/Carousel/Carousel';
import Banner from './Sections/Banner/Banner';
import useDeviceType from '../../global/utils/hooks/useDeviceType';
import { Toast } from 'primereact/toast';

const PRODUCTS_URL = 'api/v1/products';
const CATEGORIES_URL = 'api/v1/categories';
const USER_LIST = 'api/v1/user/list';
const SLIDESHOWS_URL = 'api/v1/slideshows';

export default function HomePage() {
  const [featureProducts, setFeatureProducts] = useState([]);
  const [expirationProducts, setExpirationProducts] = useState([]);
  const [lowestPriceProducts, setLowestPriceProducts] = useState([]);
  const [headerCategories, setHeaderCategories] = useState([]);
  const [discoverCategories, setDiscoverCategories] = useState([]);
  const [advertiseCategories, setAdvertiseCategories] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [recentViewProducts, setRecentViewProducts] = useState({id: JSON.parse(localStorage.getItem('recentProducts')) || [], data: []});
  const [banners, setBanners] = useState([]);
  const [sortedRecentData, setSortedRecentData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const {lang} = useContext(UserContext);
  const toast = useRef(null);

  const navigate = useNavigate();

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const callCategories = async (sectionType, categorytLimit, isFeatureProduct = '', productCount = '', isDiscount = '') => {
    setIsLoading(true);

    try {
      const response = await getRequest(CATEGORIES_URL, {
        params: {
          is_feature: 1,
          type: sectionType,
          limit: categorytLimit,
          product: isFeatureProduct,
          product_limit: productCount,
          is_discount:isDiscount
        }
      })
      sectionType == 'Header' && setHeaderCategories(response.data.data);
      sectionType == 'Discover' && setDiscoverCategories(response.data.data);
      sectionType == 'Advertise' && setAdvertiseCategories(response.data.data);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
    finally {
      setIsLoading(false)
    }
  }

  const callFeatureProducts = async (sectionName, categoryId, isFeature, productLimit = 8, isDiscount = '', orderBy = '', productIds = '') => {
    setIsLoading(true);

    try {
      const response = await getRequest(PRODUCTS_URL,{
        params: {
          category_id: categoryId,
          is_feature: isFeature,
          limit: productLimit,
          is_discount: isDiscount,
          order_by: orderBy,
          product_id: productIds,

        }
      });
      let data = response.data.data;

      switch (sectionName) {
        case 'expiration':
          setExpirationProducts(data);
          break;
        case 'lowest_price':
          setLowestPriceProducts(data);
          break
        case 'features':
          setFeatureProducts(data);
          break;
        case 'recentView':
          setRecentViewProducts({...recentViewProducts, data: data});
          break;
      }

      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
    finally {
      setIsLoading(false)
    }
  }

  const callSlideshows = async () => {
    setIsLoading(true);

    try {
      const response = await getRequest(SLIDESHOWS_URL);
      setBanners(response.data.data);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
    finally{
      setIsLoading(false);
    }
  }

  //get category id from admin
  const allProductFeature = () => {
    navigate(`product-list/1`)
  }
  
  const callVendor = async () => {
    setIsLoading(true);

    try {
      const response = await getRequest(USER_LIST,{
        params: {
          is_feature: 1,
          product: 1,
          product_limit: 3,
        }
      });
      setVendorList(response?.data?.data);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      }
      setIsLoading(false); 
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    callCategories('Header', 6);
    callCategories('Discover', 8);
    callCategories('Advertise', 6, 1, 12);
    callFeatureProducts('features', '', 1, 8, '', '', '');
    callFeatureProducts('expiration','', 1, 8, '', 'expiration', '');
    callFeatureProducts('lowest_price', '', 1, 8,'', 'lowest_price','');
    recentViewProducts.id.length > 0 && callFeatureProducts('recentView', '', '', 8, '', '', recentViewProducts.id);
    callVendor();
    callSlideshows();
  },[]);


    const deviceType = useDeviceType();

    const filteredData = banners.filter((item) => item.type === deviceType);

    const firstSliderItem = filteredData.find(
      (item) => item.position === "FIRST_SLIDER"
    );

    const secondSliderItem = filteredData.find(
      (item) => item.position === "SECOND_SLIDER"
    );
    
    const mainSlider = filteredData.filter(
      (item) => item.position === "MAIN_SLIDER"
    );

  useEffect(() => {
    let sortData = [];

    if(recentViewProducts.data.length > 0){
      sortData = (recentViewProducts.id.map (id => {
        return recentViewProducts.data.find (item => item.id === id);
      }))
      sortData = sortData.filter(function(element) {
        return element !== undefined;
      })
    }
    setSortedRecentData(sortData);
  },[recentViewProducts.data]);

  return (
    <>
      <Layout>
      <Toast ref={toast} position="top-center" />

        <div className={`${styles.lgtBackOver} py-5`}>
          <div className={`${styles.lgtOverlay}`}></div>
          <div className={`container-xxl`}>
            <Row>
              <Col className={`text-center`}>
                <div className={`position-relative py-4`}>
                  <h2 className={`${styles.lgtSearchTitle} d-inline-block text-white mb-0 fw-bold me-2`}>
                    {showMsg('find_anything', lang)}<br/>
                    {showMsg('around', lang)} <span className={`text-primary`}>{showMsg('you', lang)}</span>
                  </h2>
                  <div className={`${styles.lgtArrowStyle} d-inline-block position-absolute`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="101" viewBox="0 0 52 101" fill="none">
                    <path d="M8.89495 2.24686C19.9527 1.53291 34.5287 10.8072 38.9575 18.0848C58.452 50.1189 42.6373 73.0266 13.537 93.835" stroke="#f15d22" strokeWidth="3" strokeDasharray="8"></path>
                    <path d="M12.6584 82.2992C10.7176 101.14 5.07263 97.068 22.3138 97.2478" stroke='#f15d22' strokeWidth="3"></path>
                  </svg>
                  </div>
                </div>
              </Col>              
            </Row>
            <Row>
              <Col className='text-center'>
                <Search isHomePage={true}/>
              </Col>
            </Row>
            {
              headerCategories.length > 0 && (
                <Row>
                  <Col className='text-center'>
                  {
                    isLoading 
                      ? (
                        <Row>
                          <Col className='text-center'>
                            <Spinner color='primary' className='mx-auto my-3'>
                              Loading...
                            </Spinner>
                          </Col>
                        </Row>
                      ) 
                      : (
                        <CategoriesIconSection data={headerCategories} />
                      )
                  }
                  </Col>
                </Row>

            )}
          </div>
        </div>

        {/* ==== show data list ==== */}
        <div  className={`container-xxl`}>
        {
          isLoading 
            ? (
              <Row>
                <Col className='text-center'>
                  <Spinner color='primary' className='mx-auto my-3'>
                    Loading...
                  </Spinner>
                </Col>
              </Row>
            ) 
            : (
              discoverCategories.length > 0 && (
                <>
                  <Row>
                    <Col className={styles.sectionTitle}>
                      <h2 className='mt-5 mb-3'>
                        {showMsg('discover_more',lang)}  
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    {
                      discoverCategories.map((category) => (
                        <Col xs={6} sm={6} md={3} key={category.id}>
                          <Category data={category} />
                        </Col>
                      ))
                    }
                  </Row>
                </>
              )
            )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                featureProducts.length > 0 && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('featured_listings',lang)}  
                        </h2>
                      </Col>
                      <Col sm={6} className='text-end pt-3 d-xs-none'>
                        <Button 
                          onClick={allProductFeature}
                          className={`${styles.allBtn} mb-3 mt-5 general-button`}
                        >
                          {showMsg('view_all',lang)}
                          <i className='bi bi-chevron-right ms-2'></i>
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      {
                        featureProducts.map((product) => (
                          <Col xs={12} sm={6} md={4} lg={3} key={product.id}>
                            <Product data={product} />
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                mainSlider.length > 0 && (
                  <>
                    <Row>
                      <Col xs={12} className={`text-center`}>
                        <div className='mt-5 mb-3 px-4'>
                          <Carousel desktopSlidesToShow={1} tabletSlidesToShow={1} mobileSlidesToShow={1}>
                            { mainSlider &&
                                mainSlider.map((banner) => (
                                <div className='ps-2' key={banner.id}>
                                  <Banner data={banner} />
                                </div>
                              ))
                            }
                          </Carousel>
                        </div>
                      </Col>
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                advertiseCategories.length > 0 && (
                  <>
                    <Row>
                      <Col className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('featured_categories',lang)}  
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <TabSections data={advertiseCategories}  />
                      </Col>
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                expirationProducts.length > 0 && (
                  <>
                    <Row>
                      <Col className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('expire_soon',lang)}  
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} >
                        <Carousel arrow="top" align={'left'}>
                          {
                            expirationProducts.map((product) => (
                              <div className='ps-2' key={product.id}>
                                <Product data={product} />
                              </div>
                            ))
                          }
                        </Carousel>
                      </Col>
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                banners.length > 0 && (
                  <>
                    <Row>
                      {
                        secondSliderItem && firstSliderItem 
                          ? (
                            <>
                              <Col xs={12} sm={12} md={6} lg={6} className='mt-5 mb-3 text-center' >
                                <Banner data={firstSliderItem}/>
                              </Col>
                              <Col xs={12} sm={12} md={6} lg={6} className='mt-5 mb-3 text-center' >
                                <Banner data={secondSliderItem}/>
                              </Col>
                            </>
                          )
                        : firstSliderItem 
                          ? (
                              <Col xs={12}  className={`text-center mt-5 mb-3`}>
                                <Banner data={firstSliderItem} />
                              </Col>
                            ) 
                          : (
                            secondSliderItem && 
                              <Col xs={12} className={`text-center mt-5 mb-3`}>
                                <Banner data={secondSliderItem}/>
                              </Col>
                          )}
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                lowestPriceProducts.length > 0 && (
                  <>
                    <Row>
                      <Col className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('the_cheapest_products',lang)}  
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Carousel arrow="top" align={'left'}>
                          {
                            lowestPriceProducts.map((product) => (
                              <div className='ps-2' key={product.id}>
                                <Product data={product} />
                              </div>
                            ))
                          }
                        </Carousel>
                      </Col>
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                sortedRecentData.length > 0 > 0 && (
                  <>
                    <Row>
                      <Col className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('recently_view_products', lang)}  
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Carousel arrow="top" align={'left'}>
                          {
                            sortedRecentData.length > 0 &&
                              sortedRecentData.map((product) => (
                                <div className='ps-2' key={product.id}>
                                  <Product data={product} />
                                </div>
                              ))
                          }
                        </Carousel>
                      </Col>
                    </Row>
                  </>
                )
              )
          }
          {
            isLoading 
              ? (
                <Row>
                  <Col className='text-center'>
                    {/* <Spinner color='primary' className='mx-auto my-3'>
                      Loading...
                    </Spinner> */}
                  </Col>
                </Row>
              ) 
              : (
                vendorList.length > 0 && (
                  <>
                    <Row>
                      <Col className={styles.sectionTitle}>
                        <h2 className='mt-5 mb-3'>
                          {showMsg('recommended_seller', lang)}  
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      {
                        vendorList.map((vendor) => (
                          <Col xs={12} sm={6} md={3} key={vendor.id}>
                            <VendorCard data={vendor}/>
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              )
          }
        </div>
      </Layout>
    </>
  )
}
